(function() {
	'use strict';

	angular
		.module('components')
		.controller('PackageCardComponentController', PackageCardComponentController);

	/**
	 * Our package card controller
	 * @constructor
	 * @param {Scope} $rootScope $rootScope
	 * @param {Service} AnalyticsDataLayerService For analytics
	 * @param {Service} FolioService FolioService
	 * @param {Service} GatePriceComparison GatePriceComparison
	 * @param {Service} Language Language
	 * @param {Service} Package Package
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {self} Our instance
	 * @ngInject
	 */
	function PackageCardComponentController($rootScope, AnalyticsDataLayerService, FolioService, GatePriceComparison, Language, Package, Utilities, UtilsValidation) {
		var vm = this,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			returnOrDefault = UtilsValidation.returnOrDefault,
			validString = UtilsValidation.validString,
			generateEventData = Utilities.generateEventData,
			getLocale = Language.getLocale,
			triggerAnalyticsEvent = AnalyticsDataLayerService.triggerAnalyticsEvent;

		vm.viewPackageDetails = getLocale('PackageDetails', 'viewPackageDetails');
		vm.viewOtherParkHours = getLocale('PackageDetails', 'viewOtherParkHours');
		vm.i18n = Language;
		vm.gatePricingViewSettings = GatePriceComparison.gatePricingViews;
		vm.getAssetUrl = $rootScope.getAssetUrl;
		vm.folios = [];
		vm.folioEnabled = false;
		vm.folioRestricted = false;
		vm.folioCustomerType = null;

		vm.$onChanges = $onChanges;
		vm.getCustomBannerText = getCustomBannerText;
		vm.onQtyChanged = onQtyChanged;
		vm.onMediaEnd = onMediaEnd;
		vm.onMediaPause = onMediaPause;
		vm.onMediaPlay = onMediaPlay;
		vm.setFolioLocales = setFolioLocales;
		vm.setVideoInfo = setVideoInfo;

		/**
		 * Handles data being sent into the component
		 * @param {Object} changes The changes object
		 * @returns {undefined}
		 */
		function $onChanges(changes) {
			var packageDetails;

			if (changes.packageDetails) {
				packageDetails = changes.packageDetails.currentValue;

				vm.setVideoInfo(packageDetails);
				vm.customBannerText = vm.getCustomBannerText(packageDetails);

				Package.setUpCustomerTypeGroups(vm.customerTypes);
				Package.appendOverrideCustomerTypeMaxQuantity(vm.customerTypes);

				vm.customerTypeGroups = Package.customerTypeGroups;

				vm.folios = FolioService.foliosForPackage(vm.packageDetails);
				vm.folioEnabled = UtilsValidation.validArray(vm.folios);
				vm.folioRestricted = FolioService.folioRestrictedPackage(vm.packageDetails);

				if (vm.folioEnabled) {
					vm.folioCustomerType = angular.copy(vm.customerTypes[0]);
					vm.folioCustomerType.qty = 0;
					vm.folioCustomerType.min_quantity = 0;
				} else {
					vm.folioCustomerType = null;
				}

				vm.setFolioLocales(vm.packageDetails);
			}
		}

		/**
		 * Sets the folio locales
		 * @param {Object} packageDetails The package details object
		 * @returns {undefined}
		 */
		function setFolioLocales(packageDetails) {
			var localeOverride = checkProp('packageDetails.CHARACS.folio_locale_override', packageDetails, 'returnValue');
			vm.folioHeadingTarget = 'heading';
			vm.folioDiscussionTarget = 'discussion';

			if (vm.folioCustomerType && validString(localeOverride)) {
				vm.folioHeadingTarget = 'heading_' + localeOverride;
				vm.folioDiscussionTarget = 'discussion_' + localeOverride;
				vm.packageHeadlineOverride = getLocale('FolioLabels', 'headlineOverride_' + localeOverride).replace('@@amount', vm.folioCustomerType.cusTypeRetail);
			}
		}

		/**
		 * Sets the video information if any.
		 * @param {Object} packageDetails The package details
		 * @returns {undefined}
		 */
		function setVideoInfo(packageDetails) {
			var characs = checkProp('packageDetails.CHARACS', packageDetails, 'returnValue');

			if (checkProp('CHARACS.videoTabURL', characs, validString)) {
				vm.showInfoVideo = true;
				vm.infoVideoTitle = returnOrDefault(characs.videoTabTitle, '', validString);
				vm.mediaText = returnOrDefault(characs.videoTabInfo, '', validString);
				vm.mediaPoster = returnOrDefault(characs.mediaPoster, '', validString);
				vm.mediaPath = returnOrDefault(characs.videoTabURL, '', validString);
				vm.mediaType = returnOrDefault(characs.videoTabSourceType, '', validString);
				vm.autoPlayMedia = Utilities.getBoolean(characs.autoPlayMedia);
			}
		}

		/**
		 * Returns the custom banner text for use on the new package details.
		 * @param {Object} details The package details
		 * @returns {String|undefined} The locale or undefined
		 */
		function getCustomBannerText(details) {
			var section = checkProp('details.CHARACS.details_banner_section', details, 'returnValue');
			var target = checkProp('details.CHARACS.details_banner_target', details, 'returnValue');

			if (validString(section) && validString(target)) {
				return getLocale(section, target);
			}
		}

		/**
		 * Handles the customer-quantity component changes and emitting it
		 * @param {String} type The id of the customer type
		 * @param {Number} qty The new qty
		 * @returns {undefined}
		 */
		function onQtyChanged(type, qty) {
			vm.onCustomerQtyChanged({
				packageId: vm.packageDetails.id,
				qty: qty,
				type: type
			});
		}

		/**
		 * Media playing Ended
		 * @public
		 * @returns {undefined}
		 */
		function onMediaEnd() {
			triggerAnalyticsEvent(generateEventData(vm.analyticsSection + ' - Video', 'mediaEnd', vm.packageDetails.name));
		}

		/**
		 * Media playing Paused
		 * @public
		 * @returns {undefined}
		 */
		function onMediaPause() {
			triggerAnalyticsEvent(generateEventData(vm.analyticsSection + ' - Video', 'mediaPause', vm.packageDetails.name));
		}

		/**
		 * Media started Playing
		 * @public
		 * @returns {undefined}
		 */
		function onMediaPlay() {
			triggerAnalyticsEvent(generateEventData(vm.analyticsSection + ' - Video', 'mediaPlay', vm.packageDetails.name));
		}
	}
})();
